import { useEffect, useState } from 'react';

/**
 * Sticky bottom CTA bar that slides in after the hero section scrolls out of view.
 */
export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      aria-hidden={!visible}
      className={`fixed inset-x-0 bottom-0 z-40 transition-all duration-500 ease-smooth-out ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="container-x pb-4 sm:pb-6">
        <div className="glass-strong flex items-center justify-between gap-4 rounded-full px-5 py-3 shadow-card">
          <div className="flex min-w-0 items-center gap-3">
            <span className="hidden h-9 w-9 shrink-0 place-items-center rounded-full bg-cyan-sheen font-heading font-extrabold text-navy-900 sm:grid">
              T
            </span>
            <div className="min-w-0">
              <p className="truncate font-heading text-sm font-semibold text-white">
                Ready to build something exceptional?
              </p>
              <p className="hidden truncate text-xs text-silver/70 sm:block">
                Free 30-minute consultation — no commitment.
              </p>
            </div>
          </div>
          <a href="#contact" className="btn-primary animate-pulse-glow px-5 py-2.5 text-sm">
            Start Your Project
          </a>
        </div>
      </div>
    </div>
  );
}
